import { api } from './api'
import { URL } from '../utils/constant'



export const getJuryDetails = () => api.get(URL.juryDetails);